import * as React from 'react';
import DraggableListItem from './DraggableListItem';
import {
  DragDropContext,
  Droppable,
} from 'react-beautiful-dnd';


const DraggableList = React.memo(({ items, onDragEnd, handleDeleteRate, currency }) => {

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item, index) => {
              return <DraggableListItem 
                        item={item} 
                        index={index} 
                        key={item.id.toString()} 
                        handleDeleteRate={handleDeleteRate}
                        currency={currency}
                      />
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});

export default DraggableList;
